<template>
    <div>
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-3"
        >
            <div class="title">
                <h1 class="mb-0">Subscriptions</h1>
            </div>
        </div>
        <b-card footer-class="p-0" class="rounded-lg side-tab">
            <div class="tab-body row">
                <div v-if="isLoading" class="col-12 col-md-2 tabs d-md-block">
                    <loader-custom :rowCount="3" />
                </div>
                <div v-else class="col-12 col-md-2 tabs d-md-block">
                    <div class="w-100 d-flex d-md-block nav-scrollable">
                        <div
                            class="text"
                            v-for="tab in tabs"
                            :key="tab.id"
                            :class="{ active: tab.id == selectedTab }"
                            :id="'nav-' + tab.id"
                            @click="switchTab(tab.id)"
                            v-show="tab.isShow"
                        >
                            {{ tab.label }}
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" class="col-md-10">
                    <loader-list />
                </div>
                <div v-else id="tab-details" class="col-md-10">
                    <div>
                        <SubscriptionList
                            v-if="selectedTab == 'transactions_history'"
                        />
                        <BillingList
                            v-else-if="
                                selectedTab == 'subscriptions' &&
                                billings.length
                            "
                            :billings="billings"
                        />
                        <InvoiceList
                            v-else-if="
                                selectedTab == 'invoices' && billings.length
                            "
                        />
                        <PaymentMethodList
                            v-else-if="selectedTab == 'payment_methods'"
                        />
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import SubscriptionList from "@/components/setting-subscription/subscription-list";
import InvoiceList from "@/components/setting-subscription/invoice-list";
import PaymentMethodList from "@/components/setting-subscription/payment-method-list.vue";
import BillingList from "@/components/setting-subscription/billing-list.vue";
import subscriptionService from "@/services/subscription";
import LoaderCustom from "@/components/elements/loader-custom";
import LoaderList from "@/components/elements/loader-list";

export default {
    components: {
        SubscriptionList,
        BillingList,
        PaymentMethodList,
        InvoiceList,
        LoaderCustom,
        LoaderList
    },
    data() {
        return {
            tabs: [
                {
                    id: "transactions_history",
                    label: "Transactions History",
                    isShow: true
                },
                {
                    id: "subscriptions",
                    label: "Subscriptions",
                    isShow: false
                },
                {
                    id: "invoices",
                    label: "Invoices",
                    isShow: false
                },
                {
                    id: "payment_methods",
                    label: "Payment Methods",
                    isShow: true
                }
            ],
            selectedTab: "transactions_history",
            billings: [],
            isLoading: true
        };
    },
    watch: {},
    computed: {},
    created() {
        this.queryTab();
        this.getBillings();
    },
    methods: {
        queryTab() {
            const queryTab = this.$route.query["type"];

            if (
                queryTab &&
                ["transactions_history", "payment_methods"].includes(queryTab)
            ) {
                this.selectedTab = queryTab;
            }
        },
        switchTab(tabId) {
            this.selectedTab = tabId;
        },
        async getBillings() {
            this.isLoading = true;

            const response = await subscriptionService.getSubscriptions({
                perPage: 20,
                page: 1
            });

            if (
                response.message &&
                response.message.code &&
                response.message.code == 200 &&
                response.message.response &&
                response.message.response.subscriptions &&
                response.message.response.subscriptions.length
            ) {
                this.billings = response.message.response.subscriptions;

                //NOTE: billing & Invoice tab UI on index 1,2
                this.tabs[1].isShow = true;
                this.tabs[2].isShow = true;
            } else {
                //NOTE: billing & Invoice tab UI on index 1,2
                this.tabs[1].isShow = false;
                this.tabs[2].isShow = false;
            }

            this.isLoading = false;
        }
    }
};
</script>

<style scoped>
.card-body {
    min-height: 600px;
}
</style>
